import * as React from 'react';
import { OrthodonticReferralPatientInformation } from './OrthodonticReferralPatientInformation';
import { IOrthodonticReferral } from '../../../../models/IOrthodonticReferral';
import { IPatient } from '../../../../models/IPatient';
import { OrthodonticReferralReferrerInformation } from './OrthodonticReferralReferrerInformation';
import { OrthodonticReferralConsultantInformation } from './OrthodonticReferralConsultantInformation';
import { OrthodonticReferralStatus } from './OrthodonticReferralStatus';
import { OrthodonticReferralOtherInformation } from './OrthodonticReferralOtherInformation';
import { OrthodonticReferralPatientViewing } from './OrthodonticReferralPatientViewing';
import { OrthodonticReferralTreatmentIssue } from './OrthodonticReferralTreatmentIssue';
import { OrthodonticReferralCompletionInformation } from './OrthodonticReferralCompletionInformation';
import { OrthodonticReferralTreatmentDecision } from './OrthodonticReferralTreatmentDecision';
import { OrthodonticReferralOrthodontistInformation } from './OrthodonticReferralOrthodontistInformation';
import { OrthodonticReferralTreatmentInformation } from './OrthodonticReferralTreatmentInformation';
import { OrthodonticReferralPatientOrthodonticReferrals } from './OrthodonticReferralPatientOrthodonticReferrals';
import { Textarea } from 'soprasteria-ui-library';
import { OrthodonticReferralAdvancedConsultationNeedInformation } from './OrthodonticReferralAdvancedConsultationNeedInformation';

interface IOrthodonticReferralInputs {
    orthodonticReferral: IOrthodonticReferral;
    orthodonticReferralId?: number;
    patient: IPatient;
    isFetchingOrthodonticReferral: boolean;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getOrthodonticReferral: (id: number, refresh: boolean) => void;
    hasRoleAllmantandvard: boolean;
    hasRoleOrtodontisttandvård: boolean;
}

export const OrthodonticReferralSections: React.FunctionComponent<IOrthodonticReferralInputs> = ({ orthodonticReferral, orthodonticReferralId, patient, isFetchingOrthodonticReferral, changeSuccessMessage, changeErrorMessage, getOrthodonticReferral, hasRoleAllmantandvard, hasRoleOrtodontisttandvård }) => {

    const setDefaultValue = (value: string | undefined) => {
        return value === " " || value === undefined
            ? undefined
            : value
    }

    return (
        <>
            <OrthodonticReferralStatus orthodonticReferral={orthodonticReferral} />
            {
                orthodonticReferral.reasonsForRequestedCompletion && orthodonticReferral.reasonsForRequestedCompletion.length > 0 ?
                    <OrthodonticReferralCompletionInformation reasonsForRequestedCompletion={orthodonticReferral.reasonsForRequestedCompletion} />
                    : null
            }
            {
                orthodonticReferral.orthodonticReferralAdvancedConsultationNeed && orthodonticReferralId ?
                    <OrthodonticReferralAdvancedConsultationNeedInformation orthodonticReferralAdvancedConsultationNeed={orthodonticReferral.orthodonticReferralAdvancedConsultationNeed} getOrthodonticReferral={getOrthodonticReferral} orthodonticReferralId={orthodonticReferralId} changeSuccessMessage={changeSuccessMessage} />
                    : null
            }
            <OrthodonticReferralPatientInformation orthodonticReferral={orthodonticReferral} patient={patient} />
            <OrthodonticReferralReferrerInformation orthodonticReferral={orthodonticReferral} />
            <OrthodonticReferralConsultantInformation orthodonticReferral={orthodonticReferral} />
            <OrthodonticReferralOrthodontistInformation orthodonticReferral={orthodonticReferral} />
            <div className="row readonly-less-margin">
                <div className="col-12">
                    <Textarea rows={6} labelCol={2} inputCol={10} name="orthodonticReferralReason" label="Remissorsak" defaultValue={setDefaultValue(orthodonticReferral.orthodonticReferralReason)} maxLength={100} required inlineLabel readonly={!orthodonticReferral.canEdit} />
                </div>
            </div>
            <hr />
            <OrthodonticReferralTreatmentIssue orthodonticReferral={orthodonticReferral} />
            <div className="row readonly-less-margin">
                <div className="col-12">
                    <Textarea rows={6} labelCol={2} inputCol={10} name="orthodonticReferralIssue" label="Remisstext" defaultValue={setDefaultValue(orthodonticReferral.orthodonticReferralIssue)} maxLength={8000} required inlineLabel readonly={!orthodonticReferral.canEdit} />
                </div>
            </div>
            <hr />
            <OrthodonticReferralPatientViewing orthodonticReferral={orthodonticReferral} orthodonticReferralId={orthodonticReferralId ?? 0} changeSuccessMessage={changeSuccessMessage} changeErrorMessage={changeErrorMessage} getOrthodonticReferral={getOrthodonticReferral} />
            <OrthodonticReferralOtherInformation orthodonticReferral={orthodonticReferral} isFetchingOrthodonticReferral={isFetchingOrthodonticReferral} changeSuccessMessage={changeSuccessMessage} changeErrorMessage={changeErrorMessage} getOrthodonticReferral={getOrthodonticReferral}/>
            <OrthodonticReferralPatientOrthodonticReferrals orthodonticReferral={orthodonticReferral} />
            <OrthodonticReferralTreatmentDecision orthodonticReferral={orthodonticReferral} />
            {
                orthodonticReferral.canAddOrthodonticReferralICD10CodeMapping || (orthodonticReferral.orthodonticReferralICD10Codes && orthodonticReferral.orthodonticReferralICD10Codes.length > 0)
                    || orthodonticReferral.canReportTreatments || (orthodonticReferral.treatments && orthodonticReferral.treatments.length > 0) ?
                    <OrthodonticReferralTreatmentInformation hasRoleOrtodontisttandvård={hasRoleOrtodontisttandvård}
                        hasRoleAllmantandvard={hasRoleAllmantandvard}
                        canAddOrthodonticReferralICD10CodeMapping={orthodonticReferral.canAddOrthodonticReferralICD10CodeMapping ?? false}
                        getOrthodonticReferral={getOrthodonticReferral}
                        orthodonticReferralId={orthodonticReferralId ?? 0}
                        orthodonticReferralStatusId={orthodonticReferral.orthodonticReferralStatusId ?? 0}
                        canReportTreatments={orthodonticReferral.canReportTreatments}
                        minimumTreatmentDate={orthodonticReferral.mininumTreatmentDate}
                        treatments={orthodonticReferral.treatments}
                        orthodonticReferralICD10Codes={orthodonticReferral.orthodonticReferralICD10Codes}
                        orthodonticReferralTherapy={orthodonticReferral.orthodonticReferralTherapy}
                        isICD10CodeAndTherapyRequired={orthodonticReferral.isICD10CodeAndTherapyRequired ?? false}
                        canDeleteOrthodonticReferralICD10CodeMapping={orthodonticReferral.canDeleteOrthodonticReferralICD10CodeMapping ?? false}
                        referralClosedDate={orthodonticReferral.closedDate} />
                    : null
            }
            {
                orthodonticReferral.orthodonticReferralAnswer || (orthodonticReferral.canClose && orthodonticReferral.isReferralAnswerRequired) ?
                    <>
                        <div className="row readonly-less-margin">
                            <div className="col-12">
                                <Textarea rows={6} labelCol={2} inputCol={10} name="orthodonticReferralAnswer" label="Remissvar" defaultValue={orthodonticReferral.orthodonticReferralAnswer ?? ""} maxLength={5000} required inlineLabel readonly={!(orthodonticReferral.canClose)} />
                            </div>
                        </div>
                        <hr />
                    </>
                    : null
            }

        </>
    )
}